import React from "react";
import { FiExternalLink } from "react-icons/fi";

import { cn } from "../utils/commercesUtils";

export default function CommerceContactLink({
  href,
  icon: Icon,
  label,
  external = false,
  variant = "default",
}) {
  if (!href) return null;

  const isPrimary = variant === "primary";

  return (
    <a
      href={href}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer" : undefined}
      className={cn(
        "inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border px-4 py-2 text-sm font-bold transition",
        "focus:outline-none focus:ring-2 focus:ring-[#1277B9]/40",
        isPrimary
          ? "border-[#1277B9] bg-[#1277B9] text-white shadow-sm hover:bg-[#0f659d]"
          : "border-slate-200 bg-white text-slate-700 hover:border-[#1277B9]/50 hover:bg-sky-50 hover:text-[#1277B9] dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
      )}
    >
      {Icon && <Icon className="h-4 w-4 shrink-0" />}
      <span>{label}</span>
      {external && <FiExternalLink className="h-3.5 w-3.5 opacity-70" />}
    </a>
  );
}